import React from "react";
import { View } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import LHModalPop from "../../../components/LHModalPop";
import { RootState } from "../../../store";
import {
  removeErrorById,
  hideErrorModal,
  clearCentralizedErrors,
} from "../../../store/slices/qualityAuditSlice";

// Convert camelCase api name to a readable title
const getApiTitle = (apiName: string = "") => {
  const words = apiName
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
  return `${words} Failed`;
};

const QualityAuditErrorModal: React.FC = () => {
  const dispatch = useDispatch();
  const centralized = useSelector((state: RootState) => state.qualityAudit.centralizedErrors);
  const activeError = centralized?.activeError ?? (centralized?.errors?.length > 0 ? centralized.errors[centralized.errors.length - 1] : null);
  const isVisible = centralized?.isErrorModalVisible;

  const handleClose = () => {
    if (activeError) {
      dispatch(removeErrorById(activeError.id));
    }
    dispatch(hideErrorModal());
  };

  if (!activeError) return null;

  return (
    <LHModalPop
      visible={isVisible}
      onClose={handleClose}
      title={getApiTitle(activeError.apiName)}
      description={activeError.message}
      showFooter={true}
      primaryButtonText="OK"
      secondaryButtonText=""
      onPrimaryPress={handleClose}
      showCloseButton={true}
    />
  );
};

export default QualityAuditErrorModal;
